module.exports = __webpack_public_path__ + "static/media/Phoebe Tan.48303ce5.png";